import { alpha, Skeleton, styled } from '@mui/material';

interface StateBadgeProps {
  state?: ProposalBadgeState;
  loading?: boolean;
}

export enum ProposalBadgeState {
  Created = 'Created',
  OpenForVoting = 'Open for voting',
  Passed = 'Passed',
  Failed = 'Failed',
  Executed = 'Executed',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  PartiallyExecuted = 'Partially executed',
}

type BadgeProps = {
  state: ProposalBadgeState;
};

const Badge = styled('span')<BadgeProps>(({ theme, state }) => {
  const COLOR_MAP = {
    [ProposalBadgeState.Created]: theme.palette.primary.light,
    [ProposalBadgeState.OpenForVoting]: theme.palette.success.main,
    [ProposalBadgeState.Passed]: theme.palette.success.main,
    [ProposalBadgeState.Executed]: theme.palette.success.main,
    [ProposalBadgeState.Cancelled]: theme.palette.error.main,
    [ProposalBadgeState.Expired]: theme.palette.error.main,
    [ProposalBadgeState.PartiallyExecuted]: theme.palette.warning.main,
    [ProposalBadgeState.Failed]: theme.palette.error.main,
  };
  const color = COLOR_MAP[state] || '#000';
  return theme.unstable_sx({
    ...theme.typography.subheader2,
    color,
    border: '1px solid',
    borderColor: alpha(color, 0.5),
    py: 0.5,
    px: 2,
    borderRadius: 1,
    display: 'inline-flex',
    alignItems: 'center',
  });
});

export function StateBadge({ state, loading }: StateBadgeProps) {
  if (loading || !state) return <Skeleton width={70} />;
  return <Badge state={state}>{state}</Badge>;
}

export const getProposalStates = () => {
  return Object.values(ProposalBadgeState);
};

export const stateToString = (stateToString: ProposalBadgeState) => {
  switch (stateToString) {
    case ProposalBadgeState.Created:
      return 'Created';
    case ProposalBadgeState.OpenForVoting:
      return 'Open for voting';
    case ProposalBadgeState.Passed:
      return 'Success';
    case ProposalBadgeState.Executed:
      return 'Executed';
    case ProposalBadgeState.Cancelled:
      return 'Cancelled';
    case ProposalBadgeState.Expired:
      return 'Expired';
    case ProposalBadgeState.PartiallyExecuted:
      return 'Partially executed';
    case ProposalBadgeState.Failed:
      return 'Failed';
  }
};

export const stringToState = (state: string) => {
  switch (state) {
    case 'Created':
      return ProposalBadgeState.Created;
    case 'Open for voting':
      return ProposalBadgeState.OpenForVoting;
    case 'Success':
      return ProposalBadgeState.Passed;
    case 'Executed':
      return ProposalBadgeState.Executed;
    case 'Cancelled':
      return ProposalBadgeState.Cancelled;
    case 'Expired':
      return ProposalBadgeState.Expired;
    case 'Partially executed':
      return ProposalBadgeState.PartiallyExecuted;
    case 'Failed':
      return ProposalBadgeState.Failed;
  }
};
